// Helpers para campos numéricos no padrão brasileiro.
export const parseIntBR = (v) => {
  if (v == null) { return null; }
  const s = String(v).trim().replace(/\s|\.|,/g, "");
  if (!s) { return null; }
  if (!/^-?\d+$/.test(s)) { return null; }
  return Number(s);
};

export const parseMoneyBR = (v) => {
  if (v == null || v === "") { return null; }
  if (typeof v === "number") { return v; }
  let s = String(v).trim().replace(/\s/g, "");
  // "1.234,56" -> "1234.56" ; "45320" -> "45320" ; "90,00" -> "90.00"
  if (s.includes(",")) {
    s = s.replace(/\./g, "").replace(",", ".");
  }
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
};

export const sanitizeIntInput = (v) => String(v || "").replace(/[^\d-]/g, "");
export const formatIntBR = (v) => (v == null || v === "" ? "" : Number(v).toLocaleString("pt-BR"));
